import { consola } from 'consola'
import type { NewsSliderV2, SlideGroup , SlideAction } from '../model/types'
import { useApi } from '@shared/api'




const logger = consola.withTag('api-news-slider')

class APINewsSlider {
  private readonly basePath = '/news-slider'

  async getPublic(institutionId: number | string): Promise<NewsSliderV2[]> {
    const { data } = await useApi(true).get<{ success: boolean; slides: NewsSliderV2[] }>(
      `${this.basePath}/public`,
      { params: { institution_id: institutionId } },
    )
    return data.slides ?? []
  }

  async trackView(slideId: string): Promise<void> {
    try {
      await useApi(true).get(`${this.basePath}/public/${slideId}/view`)
    }
    catch (error) {
      logger.warn('trackView failed (non-critical)', error)
    }
  }

  async trackClick(slideId: string): Promise<void> {
    try {
      await useApi(true).get(`${this.basePath}/public/${slideId}/click`)
    }
    catch (error) {
      logger.warn('trackClick failed (non-critical)', error)
    }
  }
}

export const apiNewsSlider = new APINewsSlider()
export default apiNewsSlider

/** Группирует слайды по group_id */
export const groupSlides = (slides: NewsSliderV2[]): SlideGroup[] => {
  const grouped = new Map<string, NewsSliderV2[]>()

  for (const slide of slides) {
    const key = slide.group_id || `single_${slide.id}`
    if (!grouped.has(key)) grouped.set(key, [])
    grouped.get(key)!.push(slide)
  }

  return [...grouped.entries()].map(([groupIdKey, slidesInGroup]) => {
    const sortedSlides = slidesInGroup.sort((a, b) => a.sort_order - b.sort_order)
    const resolvedGroupId = groupIdKey.startsWith('single_') ? null : groupIdKey
    return {
      group_id: resolvedGroupId,
      slides: sortedSlides,
      cover: sortedSlides[0],
    }
  })
}

/** Преобразует поля слайда из API в SlideAction для UI */
export const parseSlideAction = (slider: NewsSliderV2): SlideAction | null => {
  if (slider.action_type === 'none') return null

  return {
    type: slider.action_type as SlideAction['type'],
    data: slider.action_data || {},
    label: slider.action_label || 'Действие',
  }
}

/** Разворачивает слайд в массив для просмотра (в v2 API — один слайд) */
export const expandSlideToViewSlides = (slide: NewsSliderV2): NewsSliderV2[] => [slide]

export {type NewsSliderV2, type SlideGroup} from '../model/types'